import { IEntityWithSoftDeleteDto } from "@Interfaces/IEntities";
import { z } from "zod";
import { EntityResponseDto } from "./entity-dto";
import { UserResponseDto } from "./user-dto";

// Response Dto
export interface RoleResponseDto extends IEntityWithSoftDeleteDto {
    name?: string;
    guard?: string;
    permissions?: string[];
    entityId?: string;
    entity?: EntityResponseDto;
}

export interface UserRoleResponseDto extends IEntityWithSoftDeleteDto {
    remarks?: string;
    isDefault?: boolean;
    roleId: string;
    role: RoleResponseDto;
    userId: string;
    user: UserResponseDto;
}

// assign schema
export const roleAssignSchema = z.object({
    roleId: z.string().min(1, { message: "Role is required" }),
    permissions: z.array(z.string()),
});

// generate form types from zod validation schema
export type RoleAssignDto = z.infer<typeof roleAssignSchema>;

// Add schema
export const roleFormSchema = z.object({
    id: z.string().optional(),
    name: z.string().min(1, { message: "Name is required" }),
    entityId: z.string().optional(),
});

// generate form types from zod validation schema
export type RoleFormDto = z.infer<typeof roleFormSchema>;
